import { createTheme } from '@mui/material/styles'

export const buildAppTheme = (mode = 'light') => createTheme({
    palette: {
        mode,
        primary: {
            main: '#2563eb',
            light: '#60a5fa',
            dark: '#1d4ed8'
        },
        secondary: {
            main: '#7c3aed',
            light: '#a78bfa',
            dark: '#5b21b6'
        },
        success: { main: '#10b981' },
        warning: { main: '#f59e0b' },
        error: { main: '#ef4444' },
        info: { main: '#06b6d4' },
        background: {
            default: mode === 'dark' ? '#0b1220' : '#f0f4ff',
            paper: mode === 'dark' ? '#121a2b' : '#ffffff'
        }
    },
    shape: {
        borderRadius: 14
    },
    typography: {
        fontFamily: '"Inter", "Segoe UI", "Roboto", sans-serif',
        h4: { fontWeight: 700 },
        h5: { fontWeight: 700 },
        h6: { fontWeight: 700 }
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 20,
                    boxShadow: mode === 'dark'
                        ? '0 8px 32px rgba(0,0,0,0.4)'
                        : '0 4px 20px rgba(37,99,235,0.10)'
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: { borderRadius: 18 }
            }
        },
        MuiButton: {
            defaultProps: { disableElevation: false },
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 700,
                    borderRadius: 50,
                    paddingLeft: 20,
                    paddingRight: 20
                },
                containedPrimary: {
                    background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
                    '&:hover': { background: 'linear-gradient(135deg, #60a5fa 0%, #3b82f6 100%)' }
                },
                containedSecondary: {
                    background: 'linear-gradient(135deg, #a78bfa 0%, #7c3aed 100%)',
                    '&:hover': { background: 'linear-gradient(135deg, #c4b5fd 0%, #a78bfa 100%)' }
                },
                containedError: {
                    background: 'linear-gradient(135deg, #f87171 0%, #ef4444 100%)',
                    '&:hover': { background: 'linear-gradient(135deg, #fca5a5 0%, #f87171 100%)' }
                },
                containedSuccess: {
                    background: 'linear-gradient(135deg, #34d399 0%, #10b981 100%)',
                    '&:hover': { background: 'linear-gradient(135deg, #6ee7b7 0%, #34d399 100%)' }
                },
                containedInfo: {
                    background: 'linear-gradient(135deg, #38bdf8 0%, #06b6d4 100%)',
                    '&:hover': { background: 'linear-gradient(135deg, #7dd3fc 0%, #38bdf8 100%)' }
                },
                containedWarning: {
                    background: 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)',
                    '&:hover': { background: 'linear-gradient(135deg, #fcd34d 0%, #fbbf24 100%)' }
                }
            }
        },
        MuiTab: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '0.875rem',
                    minHeight: 46,
                    borderRadius: '10px 10px 0 0'
                }
            }
        },
        MuiTabs: {
            styleOverrides: {
                indicator: {
                    height: 3,
                    borderRadius: 3
                },
                root: {
                    borderBottom: `1px solid ${mode === 'dark' ? 'rgba(255,255,255,0.12)' : 'rgba(37,99,235,0.15)'}`
                }
            }
        },
        MuiChip: {
            styleOverrides: {
                root: { fontWeight: 600 }
            }
        },
        MuiDialog: {
            styleOverrides: {
                paper: { borderRadius: 22 }
            }
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    background: mode === 'dark'
                        ? 'linear-gradient(135deg, #1e3a5f 0%, #1e1b4b 100%)'
                        : 'linear-gradient(135deg, #dbeafe 0%, #ede9fe 100%)',
                    fontWeight: 700,
                    fontSize: '1.2rem'
                }
            }
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    borderRadius: '12px !important',
                    '&:before': { display: 'none' },
                    boxShadow: mode === 'dark' ? '0 2px 12px rgba(0,0,0,0.3)' : '0 2px 12px rgba(37,99,235,0.08)'
                }
            }
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: {
                    background: mode === 'dark'
                        ? 'linear-gradient(135deg, #1e3a5f 0%, #1e1b4b 100%)'
                        : 'linear-gradient(135deg, #2563eb 0%, #7c3aed 100%)',
                    color: '#fff',
                    borderRadius: '12px 12px 0 0',
                    fontWeight: 700,
                    '& .MuiAccordionSummary-expandIconWrapper': { color: '#fff' }
                }
            }
        }
    }
})

